export type AuthMode = 'oauth' | 'embed';

export function getAuthMode(): AuthMode {
  const params = new URLSearchParams(window.location.search);
  return params.get('mode') === 'oauth' ? 'oauth' : 'embed';
}
